module.exports = __webpack_public_path__ + "img/24_newModelWorker_zwc.fc28088a.png";